export default __webpack_public_path__ + "static/media/screen3.03d80b43.png";